/*
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2022-01-06 13:47:18
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-01-06 15:38:17
 */
import request from '../../utils/request'
import server from './config'
export default {
  /**
   * 获取咨询订单列表
   */
  drugInfo:(data)=>{
    return request({
      url:`${server.MS_PATIENT_CONSUMMER}/prescription/1/drugInfo`,
      method: 'post',
      data,
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/modules/goods.js